import React from 'react';

const SearchBar = ({ 
  placeholder = "Search...", 
  value, 
  onChange, 
  onSearch, 
  onKeyPress,
  onKeyDown,
  className = "" 
}) => {
  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && onSearch) {
      onSearch();
    }
    if (onKeyPress) {
      onKeyPress(e);
    }
  };

  const handleKeyDown = (e) => {
    if (onKeyDown) {
      onKeyDown(e);
    }
  };

  return (
    <div className={`flex gap-2 ${className}`}>
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyPress={handleKeyPress}
        onKeyDown={handleKeyDown}
        className="flex-1 px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500"
      />
      {onSearch && (
        <button
          onClick={onSearch}
          className="bg-gray-100 text-gray-700 px-6 py-2 rounded-md hover:bg-gray-200 transition-colors"
        >
          Search
        </button>
      )}
    </div>
  );
};

export default SearchBar;